import { Divider, TableCell, TableRow, Tooltip } from '@mui/material';
import { SECONDARY_BLUE_2_TRANSPARENT_10, WHITE_SMOKE } from 'utilities/colors';
import React from 'react';
import { MetadataTableButtons } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/SlideMetadataTable/MetadataTableButtons';
import { MetadataEditableField } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/SlideMetadataTable/MetadataEditableField';
import { DISPLAYED_METADATA_LABELS } from 'components/OrderSlidesList/SlideActionTabs/constants';

export const MetadataTableCell = ({
  antibodyUUID,
  alias,
  control,
  label,
  value,
  keyTooltip,
  valueTooltip,
  link,
  editable,
  isNew,
  handleEdit,
  handleSave,
  handleSubmit,
  handleCancel,
  editingRow,
  classes,
  sampleLink,
  isStaff,
}) => {
  const displayedValue = link ? (
    <a href={link} target="_blank" rel="noreferrer" className={classes.link}>
      {value}
    </a>
  ) : (
    value || '-'
  );

  const isNameField = label === DISPLAYED_METADATA_LABELS.name;
  const isNameFieldWithAlias = isNameField && alias;

  return (
    <TableRow
      key={label}
      className={classes.tableRow}
      sx={{
        backgroundColor:
          editingRow === label
            ? SECONDARY_BLUE_2_TRANSPARENT_10
            : 'transparent',
        '&:hover': {
          backgroundColor: editingRow === label ? '' : WHITE_SMOKE,
        },
      }}
    >
      <Tooltip title={keyTooltip} placement="top">
        <TableCell className={classes.labelCell}>{label}</TableCell>
      </Tooltip>
      <Divider orientation="vertical" flexItem />
      <Tooltip title={valueTooltip || value} placement="top">
        <TableCell className={classes.valueCell}>
          {editingRow === label ? (
            <MetadataEditableField
              label={label}
              value={value}
              control={control}
              classes={classes}
              isNew={isNew}
              handleSave={handleSave}
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
            />
          ) : (
            displayedValue
          )}
        </TableCell>
      </Tooltip>
      <TableCell className={classes.editCell}>
        {editable && !isNameFieldWithAlias && (
          <MetadataTableButtons
            antibodyUUID={antibodyUUID}
            label={label}
            handleEdit={handleEdit}
            editingRow={editingRow}
            isNew={isNew}
            classes={classes}
            handleSave={handleSave}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
            sampleLink={sampleLink}
            isStaff={isStaff}
          />
        )}
      </TableCell>
    </TableRow>
  );
};
